import { useAuth } from '../../hooks/useAuth'

export interface UserReport {
  url: string
  isJobRunning: boolean
  createdAt: string
}

export const useUserReportAPI = () => {
  const { authenticatedGet, authenticatedPost } = useAuth()

  const getUserReport = async () => {
    const { data } = await authenticatedGet<UserReport>('/api/v2/user-report')

    return data
  }

  const runUserReportJob = async () => {
    await authenticatedPost('/webhooks/user-report')
  }

  return { getUserReport, runUserReportJob }
}
